export default __webpack_public_path__ + "static/laptopmockWestmorelandA-ab79afe6d759e44f9d06759d2d35c232.png";